import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'


declare global {
  interface Window {
    ym?: (counterId: string | number, action: string, url?: string, options?: { title?: string }) => void
  }
}

export const useYandexMetrika = (counterId: string | number) => {
  const location = useLocation()

  useEffect(() => {
    if (typeof window === 'undefined') return
    if (!window.ym) return // если скрипт ещё не загрузился — безопасно пропускаем

    const url = location.pathname + location.search

    try {
      window.ym(counterId, 'hit', url, { title: document.title })
    } catch {
      // безопасно игнорируем ошибки метрики
      // (например, блокировщик рекламы)
      // console.debug('ym error', e);
    }
  }, [ location, counterId ])
}
